import { UserStatus } from 'modules/security/users/components/UserStatus';
import { UserRowActions } from 'modules/security/users/components/UserRowActions';
import { CellType, HeadCell } from '@dfl/mui-admin-layout';
import { createdATColumn, emailColumn, phoneColumn } from 'modules/common/constants/common.columns';
import { RolesUserCell } from 'modules/security/users/components/RolesCell';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { getFullName } from 'utils/index';
import { IUserInvite } from '../interfaces/IUserInvite';
import { UserInvitationRowActions } from '../components/UserInvitationRowActions';
import { FlexBox } from '@dfl/mui-react-common';
import { ErrorOutline } from '@mui/icons-material';
import { IUser, IUserMfa } from '../interfaces/IUser';
import { UserMfaCell } from 'modules/security/users/components/UserMfaCell';

const BUSINESS_AVATAR_BORDER = '2px solid #FDA20A';

export const userFullNameColumn = (path: string): HeadCell => ({
  field: 'fullName',
  headerName: 'users:name',
  disablePadding: false,
  renderCell: (name: string, user: IUser) => (
    <FlexBox alignItems={'center'} gap={1}>
      <AvatarNameCell
        link={`${path}/${user?._id as string}/general`}
        name={user?.fullName}
        image={user?.avatar}
        avatarProps={user?.types?.includes('BUSINESS') ? { border: BUSINESS_AVATAR_BORDER } : undefined}
      />
      {user?.riskFraud?.blockByFraud && <ErrorOutline sx={{ width: 18, height: 18 }} color='error' />}
    </FlexBox>
  ),
});

export const userStatusColumn: HeadCell = {
  field: 'status',
  headerName: 'users:status',
  component: UserStatus,
};

export const userRolesColumn: HeadCell = {
  field: 'security.roles',
  headerName: 'users:roles',
  renderCell: (roles: any) => <RolesUserCell roles={roles}></RolesUserCell>,
};

export const userMfaColumn: HeadCell = {
  field: 'security.mfa',
  headerName: 'users:mfa.column',
  sortable: false,
  renderCell: (mfa: IUserMfa) => <UserMfaCell mfa={mfa} />,
};

export const userInviteByColumn: HeadCell = {
  field: 'invitedBy',
  headerName: 'usersInvite:inviteBy',
  renderCell: (value, user: IUserInvite) => {
    return (
      <AvatarNameCell
        image={user?.invitedBy?.avatar}
        name={getFullName(user?.invitedBy?.firstName, user?.invitedBy?.lastName)}
        secondary={user?.invitedBy?.email}
        link={`/security/system-users/user/${user?.invitedBy?._id as string}/general`}
      />
    );
  },
};

export const acceptedAtColumn: HeadCell = {
  field: 'acceptedAt',
  type: CellType.DATE,
  headerName: 'common:acceptedAt',
};

export const userSystemActionsColumn: HeadCell = {
  field: 'actions',
  sortable: false,
  width: 100,
  headerName: 'actions',
  disablePadding: false,
  renderCell: (value: any, data) => <UserRowActions path='security/system-users/user' rowId={data?._id} />,
};

export const userProviderActionsColumn: HeadCell = {
  field: 'actions',
  sortable: false,
  width: 100,
  headerName: 'actions',
  disablePadding: false,
  renderCell: (value: any, data) => <UserRowActions path='security/providers-users/user' rowId={data?._id} />,
};
export const userInviteActionsColumn: HeadCell<IUserInvite> = {
  field: 'actions',
  sortable: false,
  width: 100,
  headerName: 'common:actions',
  disablePadding: false,
  renderCell: (value: any, data) => <UserInvitationRowActions data={data} />,
};

export const userSystemColumns = [
  userFullNameColumn('/security/system-users/user'),
  emailColumn,
  phoneColumn,
  userStatusColumn,
  userRolesColumn,
  userMfaColumn,
  createdATColumn,
  userSystemActionsColumn,
];

export const userProviderColumns = [
  userFullNameColumn('/security/providers-users/user'),
  emailColumn,
  phoneColumn,
  userStatusColumn,
  userRolesColumn,
  userMfaColumn,
  createdATColumn,
  userProviderActionsColumn,
];

export const userInvitationColumns = [
  emailColumn,
  userInviteByColumn,
  userRolesColumn,
  createdATColumn,
  acceptedAtColumn,
  userStatusColumn,
  userInviteActionsColumn,
];
